import { useQuery } from "react-query";
import http from "shared/http";

export interface SiteStatus {
  header: string;
  body: string;
}

const isActive = (status: SiteStatus | undefined): status is SiteStatus =>
  !!status?.header;

export const useSiteStatusQuery = () => {
  return useQuery(
    ["siteStatus"],
    async (): Promise<SiteStatus> => {
      const data = await http.fetchAsync("app/SiteStatus");
      return data as SiteStatus;
    },
    {
      staleTime: 5 * 60 * 1000,
    },
  );
};

export { isActive as isSiteStatusActive };

export const useVersionQuery = () => {
  return useQuery(
    ["appVersion"],
    async (): Promise<string> => {
      const data = await http.fetchAsync("app/Version");
      return data as string;
    },
    {
      staleTime: 0,
      refetchInterval: 2 * 60 * 1000,
      refetchIntervalInBackground: true,
    },
  );
};
